/* eslint-disable react-hooks/exhaustive-deps */
import { FC, Fragment, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { siteUrl } from "..";
import { Routes } from "../../../../../../AppRoutes";
import { CreateNotification } from "../../../../../../components/notifier";
import { approverType } from "../../../../../../constants/itCodeRequestConstants";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../../../constants/statusConstants";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { Button } from "../../../../../../modules/button";
import { MailService } from "../../../../../../services/mail/mail.service";
import { useSelector } from "../../../../../../store/store";
import ButtonGroup from "../../../../components/ButtonGroup";
import ButtonLayout from "../../../../components/ButtonLayout";
import { useProcess } from "../../../../process-context";
import { useEmployee, useUser } from "../../../../../../hook";
import { useUpdateDAR } from "../../hooks/use-update-DAR";
import { useQueryClient } from "@tanstack/react-query";
import { isDev } from "../../../../../../AppConfigs";

interface Props {
  assignList: any;
}

const FormButton: FC<Props> = (props) => {
  const { assignList } = props;
  const { Request, approvalStep, approvalType, comment } = useProcess();
  const history = useHistory();
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const { getEmployeesByEmail } = useEmployee();
  const { isThienNV, checkCurrentUser } = useUser();
  const { mutate, isLoading } = useUpdateDAR();
  const queryClient = useQueryClient();

  const checkApproval = () => {
    const { eApprovedByITLeadStatus, eAssigneeStatus, eRequestStatus } = Request.fields;
    if (eRequestStatus === requestStatus.rejected || eRequestStatus === requestStatus.completed) {
      return false;
    } else {
      if (approvalStep === approvalType) {
        return true;
      } else if (isThienNV) {
        return true;
      } else {
        if (approvalStep - approvalType === 1) {
          switch (approvalStep) {
            case approverType.itlead:
              return !eApprovedByITLeadStatus;
            case approverType.assignee:
              return !eAssigneeStatus;
            default:
              return false;
          }
        }
      }
    }
  };

  /** Mail */

  const sendMail = async (status: string) => {
    const { fields } = Request;
    const url = siteUrl + "/details/" + Request.id;
    let template = mailtemplates.find((m: any) => m.eMailType === "DARA");
    let content = template.eContent;
    let subject = template.eSubject;
    let arrApprover = fields.eApprovedByITLead.split("|");
    let name = Request.createdBy.user.displayName;
    let tomail = Request.createdBy.user.email;
    let doing = "duyệt";
    if (status === requestStatus.rejected || approvalType === approverType.assignee) {
      template =
        status === requestStatus.rejected
          ? mailtemplates.find((m: any) => m.eMailType === "DARR")
          : mailtemplates.find((m: any) => m.eMailType === "DARF");
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, url);
      if (approvalType === approverType.assignee) {
        content = content.replace(mailRegexs.one, fields.eAssigneeComment || "");
      }
      subject = template.eSubject;
    } else {
      if (approvalType === approverType.approver) {
        arrApprover = fields.eApprovedByITLead.split("|");
      }
      if (approvalType === approverType.itlead) {
        arrApprover = fields.eAssignee.split("|");
        doing = "thực hiện";
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      name = arrApprover.length > 1 ? arrApprover[1] : "";
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", doing)
        .replace(mailRegexs.two + ";", Request.createdBy.user.displayName)
        .replace(mailRegexs.nine + ";", Request.id)
        .replace(mailRegexs.ten + ";", Request.fields.eDescription ?? "")
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(Request.createdDateTime)} - ${getHHmmFormat(Request.createdDateTime)}`,
        )
        .replace(mailRegexs.siteUrl, url);
      if (approvalType === approverType.itlead && !isDev) {
        const message = MailService.buildMailMesssage(subject, content, "html", "it@viags.vn");
        await MailService.sendMail(message);
      }
    }

    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const approveRequest = () => {
    const { fields } = Request;
    let fieldsChange = "";
    const dateApprove = getUCTDate();
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = comment;
        fields.eApprovedStatus = requestStatus.approved;
        fields.eApprovedDate = dateApprove;
        if (isThienNV) fieldsChange = "eApprovedBy";
        break;
      case approverType.itlead:
        fields.eITLeadComment = comment;
        fields.eApprovedByITLeadStatus = requestStatus.approved;
        fields.eApprovedByITLeadDate = dateApprove;
        if (assignList && assignList.length > 0) {
          const employeesSelected = assignList[0];
          const assignee = getEmployeesByEmail(employeesSelected.userPrincipalName);
          fields.eAssignee = assignee
            ? `${assignee.eMail}|${assignee.Title}`
            : `${employeesSelected.userPrincipalName.toLowerCase()}|${employeesSelected.displayName}`;
        }
        if (isThienNV) fieldsChange = "eApprovedByITLead";
        break;
      case approverType.assignee:
        fields.eAssigneeComment = comment;
        fields.eAssigneeStatus = requestStatus.approved;
        fields.eAssigneeStatusDate = dateApprove;
        fields.eRequestStatus = requestStatus.completed;
        if (isThienNV) fieldsChange = "eAssignee";
        break;
      default:
        break;
    }
    if (fieldsChange) fields[fieldsChange] = "thiennv@viags.vn|Nguyễn Văn Thiện";

    mutate(
      { id: Request.id, body: fields },
      {
        onSuccess() {
          CreateNotification({
            title: "Thành công",
            body: `Đã duyệt thành công.`,
            icon: "/icons/success.png",
          });
          queryClient.invalidateQueries({ queryKey: ["delete-account-requests", Request.id] });
          sendMail(requestStatus.approved);
        },
        onError() {
          CreateNotification({
            title: "Thất bại",
            body: `Duyệt thất bại.`,
            icon: "/icons/error.png",
          });
        },
      },
    );
  };

  const rejectRequest = () => {
    const { fields } = Request;
    if (!comment) {
      const commentElement = document.getElementById("account-delete-granted");

      if (commentElement) {
        commentElement.focus();
      }

      CreateNotification({
        title: "Thông báo",
        body: "Anh Chị vui lòng nhập lưu ý khi từ chối phê duyệt vào ô phía trên !",
        icon: "/icons/warning.png",
      });
      return;
    }
    fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();
    let fieldsChange = "";

    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = comment;
        fields.eApprovedStatus = requestStatus.rejected;
        fields.eApprovedDate = dateReject;
        if (isThienNV) fieldsChange = "eApprovedBy";

        break;
      case approverType.itlead:
        fields.eITLeadComment = comment;
        fields.eApprovedByITLeadStatus = requestStatus.rejected;
        fields.eApprovedByITLeadDate = dateReject;
        if (isThienNV) fieldsChange = "eApprovedByITLead";

        break;
      case approverType.assignee:
        fields.eAssigneeComment = comment;
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        if (isThienNV) fieldsChange = "eAssignee";

        break;
      default:
        break;
    }
    if (fieldsChange) fields[fieldsChange] = "thiennv@viags.vn|Nguyễn Văn Thiện";
    mutate(
      { id: Request.id, body: fields },
      {
        onSuccess() {
          CreateNotification({
            title: "Thành công",
            body: `Từ chối thành công.`,
            icon: "/icons/success.png",
          });
          queryClient.invalidateQueries({ queryKey: ["delete-account-requests", Request.id] });
          sendMail(requestStatus.rejected);
        },
        onError() {
          CreateNotification({
            title: "Thất bại",
            body: `Từ chối thất bại.`,
            icon: "/icons/error.png",
          });
        },
      },
    );
  };

  const recoverRequest = () => {
    const { fields } = Request;
    switch (approvalType) {
      case approverType.approver:
        fields.eDeptHeadComment = "";
        fields.eApprovedStatus = "";
        fields.eApprovedDate = null;
        break;
      case approverType.itlead:
        fields.eITLeadComment = "";
        fields.eApprovedByITLeadStatus = "";
        fields.eApprovedByITLeadDate = null;
        break;
      case approverType.assignee:
        fields.eAssigneeComment = "";
        fields.eAssigneeStatus = "";
        fields.eAssigneeStatusDate = null;
        fields.eRequestStatus = requestStatus.submitted;
        break;
      default:
        break;
    }
    mutate(
      { id: Request.id, body: fields },
      {
        onSuccess() {
          CreateNotification({
            title: "Thành công",
            body: `Thu hồi thành công.`,
            icon: "/icons/success.png",
          });
          queryClient.invalidateQueries({ queryKey: ["delete-account-requests", Request.id] });
        },
        onError() {
          CreateNotification({
            title: "Thất bại",
            body: `Thu hồi thất bại.`,
            icon: "/icons/error.png",
          });
        },
      },
    );
  };

  const isApproved = checkApproval();
  const isEdit = !Request.fields.eApprovedStatus && !Request.fields.eAssigneeStatus;
  const isCurrentUser = checkCurrentUser(Request.createdBy.user.email.toLowerCase());

  const btnGroups = useMemo(() => {
    return [
      {
        hidden: !isCurrentUser || isApproved || !isEdit,
        content: (
          <Fragment>
            <Button
              className="mr5"
              buttonType="success"
              label="Chỉnh sửa"
              onClick={() => {
                history.push(Routes.createDeleteUserAccount.path.replace(":id", Request.id));
              }}
              disabled={isLoading}
            />
          </Fragment>
        ),
      },
      {
        hidden: !isApproved,
        content: [
          {
            hidden: approvalStep !== approvalType,
            content: [
              {
                hidden: false,
                content: (
                  <Fragment>
                    <Button
                      className="mr10"
                      buttonType="success"
                      label={
                        approvalStep === approvalType && approvalStep === approverType.assignee
                          ? "Hoàn thành"
                          : "Đồng ý"
                      }
                      onClick={approveRequest}
                      disabled={isLoading}
                    />

                    <Button
                      buttonType="grey"
                      label="Không đồng ý"
                      onClick={rejectRequest}
                      className="mr10"
                      disabled={isLoading}
                    />
                  </Fragment>
                ),
              },
              {
                hidden: !isCurrentUser || !isEdit,
                content: (
                  <Button
                    className="mr5"
                    buttonType="warning"
                    label="Chỉnh sửa"
                    onClick={() => {
                      history.push(Routes.createDeleteUserAccount.path.replace(":id", Request.id));
                    }}
                    disabled={isLoading}
                  />
                ),
              },
            ],
          },
          {
            hidden: approvalStep === approvalType,
            content: <Button buttonType="grey" label="Thu hồi" onClick={recoverRequest} disabled={isLoading} />,
          },
        ],
      },
      {
        hidden: false,
        content: (
          <Button
            className="ml5"
            buttonType="info"
            label="Tạo lại phiếu"
            onClick={() => {
              history.push(Routes.renewDeleteUserAccount.path.replace(":id", Request.id));
            }}
            disabled={isLoading}
          />
        ),
      },
    ];
  }, [
    approvalStep,
    approvalType,
    approveRequest,
    isApproved,
    isEdit,
    isCurrentUser,
    Request.id,
    history,
    recoverRequest,
    rejectRequest,
  ]);

  // if (!(isCurrentUser && isEdit) && !isApproved) {
  //   return null;
  // }

  return (
    <ButtonLayout smFixed>
      <ButtonGroup data={btnGroups} getItemHidden={(item) => item.hidden} renderContent={(item) => item.content} />
    </ButtonLayout>
  );
};

export default FormButton;
